import { DetailPageActionTypes } from './constants'
import { Action } from 'redux'

export type TriggerPurchasingTransition = {
  offerAsin: string,
  canonicalTitleId: string | undefined,
  isSeasonPurchase: boolean,
  purchasingText: string,
  errorHeader: string,
}

export type RemoveActionBoxTransitionPayload = {
  offerAsin?: string,
  canonicalTitleId?: string,
}

export interface ITriggerPurchasingTransition extends Action {
  type: typeof DetailPageActionTypes.TriggerPurchasingTransition
  payload: TriggerPurchasingTransition
}

export interface IResetPurchasingTransition extends Action {
  type: typeof DetailPageActionTypes.ResetPurchasingTransition
  payload: RemoveActionBoxTransitionPayload
}

export interface IFailedPurchasingDueToClientDependency extends Action {
  type: typeof DetailPageActionTypes.FailedPurchasingDueToClientDependency
  payload: RemoveActionBoxTransitionPayload
}

export const triggerPurchasingTransition = (payload: TriggerPurchasingTransition): ITriggerPurchasingTransition => ({
  type: DetailPageActionTypes.TriggerPurchasingTransition,
  payload
})

export const resetPurchasingTransition = (payload: RemoveActionBoxTransitionPayload) => ({
  type: DetailPageActionTypes.ResetPurchasingTransition,
  payload,
})

export const failedPurchasingDueToClientDependency = (payload: RemoveActionBoxTransitionPayload) => ({
  type: DetailPageActionTypes.FailedPurchasingDueToClientDependency,
  payload,
})